import { Action } from '@ngrx/store';
import { VehicleType } from '@polaris-customerweb/sharedcomponents.core';
import type { StyleSpecification } from 'mapbox-gl';

export const MapAction = {
    closeMapRightSidenav: '[map] close map right sidenav',
    closeMapSidenav: '[map] close map sidenav',
    openMapRightSidenav: '[map] open map right sidenav',
    openMapSidenav: '[map] open map sidenav',
    setMapStyle: '[map] set map style',
    setRideType: '[map] set ride type',
};

export class CloseMapSidenav implements Action {
    type = MapAction.closeMapSidenav;
}

export class OpenMapSidenav implements Action {
    type = MapAction.openMapSidenav;
}

export class CloseMapRightSidenav implements Action {
    type = MapAction.closeMapRightSidenav;
}
export class OpenMapRightSidenav implements Action {
    type = MapAction.openMapRightSidenav;
}

export class SetMapStyle implements Action {
    type = MapAction.setMapStyle;
    constructor(public style: StyleSpecification) {}
}

export class SetRideType implements Action {
    type = MapAction.setRideType;
    constructor(public rideType: VehicleType) {}
}
